var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.error)?_c('div',{staticClass:"alert alert-warning mx-auto w-75"},[_vm._v(_vm._s(_vm.error))]):_c('span',[_vm._v(_vm._s(_vm.$t("please-wait")))])])}
var staticRenderFns = []

export { render, staticRenderFns }